<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';
import { input } from '../utils/minhaLaisOptions';

const form = defineModel({
  type: Object,
  required: true,
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <section class="space-y-1">
    <h2 class="text-[16px] font-semibold text-lais-text">
      Personalizações de comportamento
    </h2>
    <p class="text-[13px] text-lais-text-muted">
      Ajustes que mudam como a Lais qualifica, retoma conversas e fala com seus
      clientes.
    </p>
  </section>

  <LaisCard title="Reengajamento de clientes">
    <p class="mb-2 text-[14px] font-semibold text-lais-text">
      Como a Lais deve lidar com leads que pararam de responder?
    </p>
    <p class="text-[13px] text-lais-text-muted mb-4">
      Quando um cliente para de responder, a Lais pode tentar reengajá-lo
      automaticamente até que ele se qualifique. Status do cliente durante o
      processo:
      <strong>Não pronto → Qualificado → Pronto para atendimento</strong>.
    </p>
    <label class="inline-flex items-center gap-2 mb-4 cursor-pointer">
      <input
        v-model="form.reengajamento_ativo"
        type="checkbox"
        class="size-4 accent-lais-primary"
      />
      <span class="text-[13px] font-semibold text-lais-text">
        Ativar reengajamento automático
      </span>
    </label>
    <LaisField
      v-if="form.reengajamento_ativo"
      label="Tentar a cada (dias)"
      helper="A Lais aguarda esse período antes de uma nova tentativa"
    >
      <input
        v-model.number="form.reengajamento_dias"
        type="number"
        min="1"
        :class="input"
      />
    </LaisField>
  </LaisCard>
</template>
